import { render, staticRenderFns } from "./BorrowerArchive.vue?vue&type=template&id=98f09990&scoped=true"
import script from "./BorrowerArchive.vue?vue&type=script&lang=js"
export * from "./BorrowerArchive.vue?vue&type=script&lang=js"
import style0 from "./BorrowerArchive.vue?vue&type=style&index=0&id=98f09990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f09990",
  null
  
)

export default component.exports